export default "__VITE_ASSET__bd495a75__"